import { Component, Input } from '@angular/core';

@Component({
  selector: 'total-target-values',
  templateUrl: './total-target-values.component.html',
  styleUrls: ['./total-target-values.component.scss']
})
export class TotalTargetValuesComponent {
  @Input() total: string;
  @Input() target: string;
}
